import { EventEmitter } from '@angular/core';
import { BroadridgeIntegrationService } from 'IntegrationsApp/ts/services/broadridge-integration-service';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/broadridge-integration-service";
import * as i2 from "@angular/common";
import * as i3 from "@angular/forms";
import * as i4 from "../../../../../../../../../../../ycharts/static/ts/features/components/loaders/loading-symbol/loading-symbol.component";
import * as i5 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/modal-base.component";
import * as i6 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-footer.component";
import * as i7 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/modal-base/components/simple-modal-header.component";
function BroadridgeIntegrationActivateModalComponent_ycn_loading_symbol_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-loading-symbol", 8);
} if (rf & 2) {
    i0.ɵɵproperty("loaderMessage", "Logging in to Broadridge...");
} }
function BroadridgeIntegrationActivateModalComponent_div_4_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 18);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("textContent", ctx_r1.errorMessage);
} }
function BroadridgeIntegrationActivateModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10)(2, "div", 11)(3, "form", 12);
    i0.ɵɵtemplate(4, BroadridgeIntegrationActivateModalComponent_div_4_div_4_Template, 1, 1, "div", 13);
    i0.ɵɵelementStart(5, "div", 14)(6, "div", 15);
    i0.ɵɵtext(7, "Public Key:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "input", 16, 0);
    i0.ɵɵlistener("blur", function BroadridgeIntegrationActivateModalComponent_div_4_Template_input_blur_8_listener() { i0.ɵɵrestoreView(_r1); const publicKeyInput_r3 = i0.ɵɵreference(9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setPublicKey(publicKeyInput_r3.value)); })("keydown.enter", function BroadridgeIntegrationActivateModalComponent_div_4_Template_input_keydown_enter_8_listener() { i0.ɵɵrestoreView(_r1); const privateKeyInput_r4 = i0.ɵɵreference(14); return i0.ɵɵresetView(privateKeyInput_r4.blur()); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "div", 14)(11, "div", 15);
    i0.ɵɵtext(12, "Private Key:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "input", 17, 1);
    i0.ɵɵlistener("blur", function BroadridgeIntegrationActivateModalComponent_div_4_Template_input_blur_13_listener() { i0.ɵɵrestoreView(_r1); const privateKeyInput_r4 = i0.ɵɵreference(14); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.setPrivateKey(privateKeyInput_r4.value)); })("keydown.enter", function BroadridgeIntegrationActivateModalComponent_div_4_Template_input_keydown_enter_13_listener() { i0.ɵɵrestoreView(_r1); const privateKeyInput_r4 = i0.ɵɵreference(14); return i0.ɵɵresetView(privateKeyInput_r4.blur()); });
    i0.ɵɵelementEnd()()()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.errorMessage !== "");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("placeholder", "Enter Broadridge Public Key");
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("placeholder", "Enter Broadridge Private Key");
} }
export class BroadridgeIntegrationActivateModalComponent {
    constructor(broadridgeIntegrationService) {
        this.broadridgeIntegrationService = broadridgeIntegrationService;
        this.updateStatusHandler = new EventEmitter();
        this.modalOpen = false;
        this.publicKey = '';
        this.privateKey = '';
        this.errorMessage = '';
        this.loading = false;
    }
    openModal() {
        this.modalOpen = true;
    }
    closeModal() {
        this.modalOpen = false;
        this.errorMessage = '';
        this.updateStatusHandler.emit(false);
    }
    setPublicKey(publicKey) {
        this.publicKey = publicKey;
    }
    setPrivateKey(privateKey) {
        this.privateKey = privateKey;
    }
    activateHandler() {
        if (this.publicKey !== '' && this.privateKey !== '') {
            this.loading = true;
            this.broadridgeIntegrationService.activateBroadridgeIntegration(this.publicKey, this.privateKey).subscribe({
                next: (res) => {
                    if (res.status === 200) {
                        this.closeModal();
                        this.updateStatusHandler.emit(true);
                    }
                },
                error: (error) => {
                    if (error.status === 403) {
                        this.loading = false;
                        this.errorMessage = 'Something went wrong, check that your public and private keys are correct';
                    }
                    else if (error.status === 424) {
                        this.loading = false;
                        this.errorMessage = 'Service unavailable, please try again later';
                    }
                    else if (error.status === 401) {
                        this.loading = false;
                        this.errorMessage = 'Invalid Request.';
                    }
                    this.updateStatusHandler.emit(false);
                },
                complete: () => {
                    this.loading = false;
                },
            });
        }
    }
}
BroadridgeIntegrationActivateModalComponent.ɵfac = function BroadridgeIntegrationActivateModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || BroadridgeIntegrationActivateModalComponent)(i0.ɵɵdirectiveInject(i1.BroadridgeIntegrationService)); };
BroadridgeIntegrationActivateModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: BroadridgeIntegrationActivateModalComponent, selectors: [["ycn-broadridge-integration-activate-modal"]], outputs: { updateStatusHandler: "updateStatusHandler" }, standalone: false, decls: 6, vars: 7, consts: [["publicKeyInput", ""], ["privateKeyInput", ""], [3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], [3, "loaderMessage", 4, "ngIf"], ["class", "modal-section", 4, "ngIf"], [3, "cancelHandler", "submitHandler", "submitButtonText", "disableSubmission"], [3, "loaderMessage"], [1, "modal-section"], [1, "row"], [1, "col"], ["action", "javascript:void(0);"], ["class", "form-row text-red", 3, "textContent", 4, "ngIf"], [1, "form-row"], [1, "form-label", "form-label-thin"], ["type", "text", "autocomplete", "public key", 1, "form-control", 3, "blur", "keydown.enter", "placeholder"], ["type", "password", "autocomplete", "current-password", 1, "form-control", 3, "blur", "keydown.enter", "placeholder"], [1, "form-row", "text-red", 3, "textContent"]], template: function BroadridgeIntegrationActivateModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 2);
        i0.ɵɵlistener("closeModalHandler", function BroadridgeIntegrationActivateModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 3);
        i0.ɵɵlistener("closeModalHandler", function BroadridgeIntegrationActivateModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 4);
        i0.ɵɵtemplate(3, BroadridgeIntegrationActivateModalComponent_ycn_loading_symbol_3_Template, 1, 1, "ycn-loading-symbol", 5)(4, BroadridgeIntegrationActivateModalComponent_div_4_Template, 15, 3, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "ycn-simple-modal-footer", 7);
        i0.ɵɵlistener("cancelHandler", function BroadridgeIntegrationActivateModalComponent_Template_ycn_simple_modal_footer_cancelHandler_5_listener() { return ctx.closeModal(); })("submitHandler", function BroadridgeIntegrationActivateModalComponent_Template_ycn_simple_modal_footer_submitHandler_5_listener() { return ctx.activateHandler(); });
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-dialog")("open", ctx.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Activate Broadridge Integration");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", !ctx.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("submitButtonText", "Log in to Broadridge")("disableSubmission", ctx.loading || ctx.publicKey === "" || ctx.privateKey === "");
    } }, dependencies: [i2.NgIf, i3.ɵNgNoValidate, i3.NgControlStatusGroup, i3.NgForm, i4.LoadingSymbolComponent, i5.ModalBaseComponent, i6.SimpleModalFooterComponent, i7.SimpleModalHeaderComponent], encapsulation: 2 });
